import { Country } from "../models/country";
import { List } from "immutable";

export interface CountryState {
    countries: List<Country>;
    initialized: boolean;
    loading: boolean;
}

export const initialState: CountryState = {
    countries: List(),
    initialized: false,
    loading: true,
};



// WEBPACK FOOTER //
// ./src/store/CountryState.ts